var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex flex-column align-center justify-center mx-md-4 my-md-4 elevation-0 py-16",attrs:{"outlined":""}},[_c('img',{attrs:{"src":_vm.InputMarkImage,"alt":"student-setting"}}),_c('span',{staticClass:"mt-4"},[_vm._v("\n    Vui lòng cung cấp các thông tin ở trên, sau đó ấn [Phân quyền] để thiết lập quyền\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }